import { createApp } from 'vue'
import Antd from 'ant-design-vue';
import App from './App.vue'
import router from './router'
import 'ant-design-vue/dist/antd.css';
import '../src/assets/fonts/js/NotoSansThai-Bold-bold'
import '../src/assets/fonts/js/NotoSansThai-Regular-normal'
import '../src/assets/fonts/js/THSarabunNew-normal'
import '../src/assets/fonts/js/THSarabunNew Bold-bold'


createApp(App)
    .use(router)
    .use(Antd)
    .mount('#app')
